<div class="badge-creation-container">
  <app-badge-template-toolbar [selectedTemplate]="selectedTemplate" [badgeForm]="badgeForm" class="toolbar-section"></app-badge-template-toolbar>
  <app-badge-template-design-area [selectedTemplate]="selectedTemplate" [badgeForm]="badgeForm" class="design-section"></app-badge-template-design-area>
</div>
